import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@mui/styles';
import Slider from '@mui/material/Slider';
import Tooltip from '@mui/material/Tooltip';
import { Theme } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfSliderProps {}
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '60%',
    margin: '0 10px',
    position: 'relative',
  },
  '@global': {
    '.custom-tooltip': {
      backgroundColor: 'white !important',
      color: '#000',
      margin: '0px !important',
      padding: '0px !important',
    },
  },
}));

const iOSBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

const IOSSlider = withStyles({
  root: {
    padding: '5px 0',
    background: 'linear-gradient(90deg, #2ad28b 30%, #F4732E 60%)',
    pointerEvents: 'auto',
    outline: 'solid 0px',
    border: '0px solid',
    borderRadius: 500,
    width: '100%',
    transition: 'box-shadow 0.2s ease-in-out',
    overflow: 'hidden',
    height: 7,
    appearance: 'none',
    backgroundImage:
      'linear-gradient(to right, rgb(102, 187, 106), rgb(249, 168, 37), rgb(211, 47, 47))',
  },
  thumb: {
    height: 18,
    width: 18,
    backgroundColor: 'transparent',
    border: '3px solid white',
    pointerEvents: 'none',
    marginTop: 0,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + -6px)',
    top: 22,
    '& *': {
      background: 'transparent',
      font: 'normal normal 600 16px/18px Open Sans !important',
      color: '#7C96A3',
    },
  },
  track: {
    height: 0,
    border: 'none',
  },
  rail: {
    opacity: 1,
    height: 0,
  },
  mark: {
    backgroundColor: '#000',
    height: 8,
    width: 1,
    marginTop: -3,
  },
  markActive: {
    opacity: 1,
  },
})(Slider);

/**
 * Custom value label component for the slider.
 * @param props - Props containing children and value for the tooltip.
 * @example
 */
function ValueLabelComponent(props: {
  children: React.ReactElement;
  value: number;
}) {
  const { children, value } = props;

  return (
    <Tooltip
      open
      enterTouchDelay={0}
      placement="bottom"
      style={{ background: '#fff' }}
      sx={{
        '&.MuiTooltip-tooltip': {
          background: 'white !important',
        },
      }}
      classes={{ tooltip: 'custom-tooltip' }}
      title={
        <span style={{ fontSize: '12px', color: '#000', background: 'white' }}>
          {value}
        </span>
      }
    >
      {children}
    </Tooltip>
  );
}

/**
 * linear gradient slider from react material slider
 * @param props - slider props
 * @example - <CcfSlider />
 */
export function CcfSlider() {
  const classes = useStyles();
  const [value, setValue] = useState(0.78);

  return (
    <div className={classes.root}>
      <IOSSlider
        aria-label="ios slider"
        min={0}
        max={4}
        defaultValue={0.78}
        value={value}
        onChange={(_: any, newValue: number | number[]) => {
          setValue(newValue as number);
        }}
        components={{ ValueLabel: ValueLabelComponent }}
        valueLabelDisplay="on"
      />
    </div>
  );
}

export default CcfSlider;
